import 'css-chunksrc/client/scenes/listEdition/styles.scss';export default {
  "listEdition": "_listEdition_14feo_1",
  "buttons": "_buttons_14feo_13",
  "action": "_action_14feo_22",
  "button": "_button_14feo_13",
  "confirmationButton": "_confirmationButton_14feo_57"
};